import {
  boronDopedPdf,
  diamistPdf,
  diamondCoatedMechanicalSealPdf,
  diamondCoatedPdf,
  electrolytePdf,
  images,
} from "../source";

export const productData = [
  // {
  //   id: 1,
  //   title: "DIAMIST",
  //   img: images.productDiamist.image,
  //   // link: diamistPdf,
  //   link: "https://www.kreova.com/",
  //   linkType: "external",
  //   ctaText: "View More",
  // },
  {
    id: 2,
    title: "BORON DOPED DIAMOND ELECTRODES",
    img: images.productElectrode.image,
    link: boronDopedPdf,
    class: "boron_img",
    ctaText: "View Product Brochure",
  },
  {
    id: 3,
    title: "ELECTROLYTIC OZONE GENERATORS",
    img: images.productGenerator.image,
    link: electrolytePdf,
    class: "electrode_img",
    linkType: "external",
    ctaText: "View Product Brochure",
  },
  {
    id: 4,
    title: "DIAMOND COATED MECHANICAL SEALS",
    img: images.productMechanicalSeals.image,
    link: diamondCoatedMechanicalSealPdf,
    class: "mechnical_img",
    ctaText: "View Product Brochure",
  },
  {
    id: 5,
    title: "DIAMOND COATED SILICON WAFERS",
    img: images.productWafer.image,
    link: diamondCoatedPdf,
    class: "wafer_img",
    ctaText: "View Product Brochure",
  },
];
